import * as THREE from 'three'

export default class WebcamTexture {
    constructor() {
        // Create a video element
        this.video = document.createElement('video');
        this.video.autoplay = true;
        this.video.muted = true; // Optional: mute video feed
        this.video.playsInline = true; // Ensures it plays inline on mobile browsers

        // Request access to the webcam
        navigator.mediaDevices.getUserMedia({ 
            video: {
                width: { ideal: 1920 }, // Request 1920x1080 resolution
                height: { ideal: 1080 }
            }
        
        })
            .then((stream) => {
                this.video.srcObject = stream;
                this.video.play(); // Start playing the video stream

                // Wait for video metadata to load (e.g., video width/height)
                this.video.addEventListener('loadedmetadata', () => {
                    // console.log(this.video.videoWidth, this.video.videoHeight);
                    // Once metadata is loaded, you can access video dimensions
                    const aspectRatio = this.video.videoWidth / this.video.videoHeight;
                    // You can now use the aspect ratio for other purposes, like creating a geometry
                });                
            })
            .catch((error) => {
                console.error('Webcam access denied:', error);
            });

        // Create a VideoTexture from the video element
        this.videoTexture = new THREE.VideoTexture(this.video);
        this.videoTexture.minFilter = THREE.LinearFilter;
        this.videoTexture.magFilter = THREE.LinearFilter;

        
        this.videoTexture.format = THREE.RGBFormat;

        // Set encoding to sRGB for better color saturation
        this.videoTexture.encoding = THREE.sRGBEncoding;
        
        //return this.videoTexture;

    }
    
    // Stop the webcam stream and clean up resources
    stopVideo() {
        if (this.stream) {
            // Stop each track
            this.stream.getTracks().forEach((track) => {
                track.stop();
                console.log(`Stopped track: ${track.kind}`);
            });
            this.stream = null; // Clear the stream reference
        }
    
        if (this.video) {
            this.video.srcObject = null; // Disconnect the video element from the stream
            //this.video.pause();
            this.video.removeAttribute('src'); // Clear the video source
            this.video.load(); // Reset the video element
            console.log('Stopped video')

            // Optionally, remove the video element from the DOM
            this.video.remove();
            this.video = null; // Clear the reference
            console.log('Video element removed');
        }
    }    


}